"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreYouPatientContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AreYouPatientContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: stretch;
  gap: 64px;
  height: 282px;
  padding: 40px;
  flex: 1;

  h1 {
    color: #7b4ef8;
    text-align: center;
  }

  .are-you-patient-buttons {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
  }

  button {
    cursor: pointer;
    border: none;
    color: white;
    border-radius: 18px;
    background-color: #7b4ef8;
    font-family: Inter, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    padding: 12px;
  }

  @media screen and (min-width: 768px) {
    button {
      border-radius: 18px;
      font-size: 42px;
      line-height: 50px;
      padding: 20px 23px;
    }
  }

  @media screen and (min-width: 1300px) {
    .are-you-patient-buttons {
      gap: 24px;
    }

    button {
      border-radius: 35px;
      font-size: 54px;
      line-height: 64px;
      padding: 20px 45px;
    }
  }
`;
